import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

// Web version of the "Fight For Yourself" pin button — clean: pink circle, motif only, no outline.
// Sits on the hero pouch image corner and links to the pin product page.
const PinBadge = ({ size = 112, className = "" }) => {
  const navigate = useNavigate();
  return (
    <motion.button
      onClick={() => navigate("/product/ffy-button")}
      whileHover={{ rotate: -6, scale: 1.06 }}
      whileTap={{ scale: 0.96 }}
      transition={{ type: "spring", stiffness: 300, damping: 18 }}
      className={`relative block cursor-pointer ${className}`}
      style={{ width: size, height: size }}
      data-testid="hero-pin-button"
      aria-label="Fight For Yourself Button ansehen"
    >
      <svg viewBox="0 0 260 260" className="w-full h-full" style={{ overflow: "visible" }}>
        <defs>
          <radialGradient id="pinPink" cx="38%" cy="32%" r="80%">
            <stop offset="0%" stopColor="#FFD6E3" />
            <stop offset="55%" stopColor="#FFAECC" />
            <stop offset="100%" stopColor="#FF92BA" />
          </radialGradient>
        </defs>

        {/* pin body — no outline */}
        <circle cx="130" cy="130" r="126" fill="url(#pinPink)" />

        {/* stacked type */}
        <g fill="#09090B" fontFamily="Saira Condensed, sans-serif" fontWeight="900" transform="rotate(-2 130 140)">
          <text x="30" y="112" fontSize="54" letterSpacing="1">FIGHT</text>
          <rect x="28" y="124" width="96" height="46" fill="#D4FF00" />
          <text x="34" y="162" fontSize="46" letterSpacing="1">FOR</text>
          <text x="28" y="216" fontSize="47" letterSpacing="0.5">YOURSELF</text>
        </g>

        {/* lime winking smiley */}
        <g transform="rotate(6 190 78)">
          <circle cx="190" cy="78" r="48" fill="#D4FF00" stroke="#09090B" strokeWidth="6" />
          {/* open eye */}
          <ellipse cx="173" cy="61" rx="6" ry="11" fill="#09090B" transform="rotate(-12 173 61)" />
          {/* wink */}
          <path d="M 201 55 q 13 4 7 17" fill="none" stroke="#09090B" strokeWidth="5.5" strokeLinecap="round" />
          {/* smile */}
          <path d="M 164 86 q 22 28 50 2" fill="none" stroke="#09090B" strokeWidth="6.5" strokeLinecap="round" />
        </g>
      </svg>
    </motion.button>
  );
};

export default PinBadge;
